import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BomTreeItem } from './models/bom-tree-item.model';
import { CreateBomItemRequestDto } from './dtos/create-bom-item-request.dto';
import { CreateBomItemResponseDto } from './dtos/create-bom-item-response.dto';
import { PatchBomItemRequestDto } from './dtos/patch-bom-item-request.dto';
import { CreateBomRelationResponseDto } from './dtos/create-bom-relation-response.dto';
import { CreateBomRelationRequestDto } from './dtos/create-bom-relation-request.dto';

@Injectable({ providedIn: 'root' })
export class BomTreeProvider {
  constructor(private http: HttpClient) {}

  getBomTree(id: number): Observable<BomTreeItem> {
    const url = `/api/bom/${id}/tree`;
    return this.http.get<BomTreeItem>(url);
  }

  createBomItem(request: CreateBomItemRequestDto): Observable<CreateBomItemResponseDto> {
    const url = `/api/bom`;
    return this.http.post<CreateBomItemResponseDto>(url, request);
  }

  deleteBomItem(id: number): Observable<void> {
    const url = `/api/bom/${id}`;
    return this.http.delete<void>(url);
  }

  patchBomItem(id: number, request: PatchBomItemRequestDto): Observable<void> {
    const url = `/api/bom/${id}`;
    return this.http.patch<void>(url, request);
  }

  attachChild(bomItemId: number, parentBomItemId: number, amount = 1): Observable<CreateBomRelationResponseDto> {
    const url = `/api/bom/${bomItemId}/relations`;
    const request: CreateBomRelationRequestDto = {
      parentBomItemId,
      amount
    };
    return this.http.post<CreateBomRelationResponseDto>(url, request);
  }
}
